const WhyChooseUsAboutPage = () => {
    return (

        <section className="same_space pt-0 why_choose_about_page">
            <div className="container">
                <div className="row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <div className="why_choose_imgdata why_chosse_image">
                            <img src="images/About-page-why-choose.png" alt="" />
                        </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <div className="hedding_why_choose">
                            <span>Why Choose Us</span>
                            <h2>Sparks Heating and Air: Expert HVAC Services</h2>
                            <p>For over 8 years, Sparks Heating and Air has been providing exceptional HVAC services to the
                                community. We are dedicated to delivering fast, affordable, reliable solutions that exceed
                                your expectations</p>
                            <p>
                                Our team of skilled technicians is available to handle any heating or cooling emergency. We
                                pride ourselves on our transparent pricing and commitment to customer satisfaction. With
                                100's of satisfied customers and a 93% first-time fix rate, you can trust Sparks Heating and
                                Air to get the job done right.Choose Sparks Heating and Air for expert service, affordable
                                prices, and a comfortable home.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default WhyChooseUsAboutPage;